import React from 'react';
import { errors } from '../constants';
import { isCIK } from '../utils/validations';
import { appTypeIds, urls, reportingStandards } from '.';

const SEC = {
  id: reportingStandards.SEC,
  testId: 'reporting-standard-sec',
  component: () => (
    <>
      The company is subject to the reporting obligations under Section 13 or
      15(d) of the Exchange Act.
    </>
  ),
  details: {
    label: 'Enter the 10-digit Central Index Key (CIK) assigned by the SEC.',
    placeholder: 'Provide CIK here.',
    fieldName: 'cikNumber',
    height: 40,
    maxLength: 10,
    isRequired: false,
    inputType: 'textbox',
    errorText: (value) => (value && !isCIK(value) ? errors.CIK : null),
    isValid: (value) => (value ? isCIK(value) : true),
  },
};

const REGULATION = {
  id: reportingStandards.REGULATION,
  testId: 'reporting-standard-regulation-a',
  desc: 'The company is subject to the reporting obligations under Tier 2 of Regulation A under the Securities Act.'
};

const ALTERNATIVE = {
  id: reportingStandards.ALTERNATIVE,
  testId: 'reporting-standard-alternative',
  component: () => <>
    The company is not subject to SEC or Regulation A reporting requirements, and intends to make disclosure pursuant to the <a href={urls.OTCQX_OTCQB_GUIDELINES} target='_blank' rel='noopener noreferrer'>OTCQX and OTCQB U.S. Disclosure Guidelines.</a>
  </>
};

const INTERNATIONAL = {
  id: reportingStandards.INTERNATIONAL,
  testId: 'reporting-standard-international',
  component: () => <>
    The Company is not a U.S. Company, is listed on a <a href={urls.QFE} target='_blank' rel='noopener noreferrer'>Qualified Foreign Exchange</a>, is compliant with the disclosure requirements of Exchange Act Rule 12g3-2(b) (see <a href={urls.CERT_SAMPLE} target='_blank' rel='noopener noreferrer'>certification sample</a>) and prepares its financial statements in accordance with US GAAP, IFRS or an IFRS equivalent standard.
  </>
};

const DNS_BANK = {
  id: reportingStandards.BANK,
  testId: 'reporting-standard-us-bank',
  component: () => (
    <>
      The Company is not subject to SEC or Reg A Reporting requirements, but
      will provide all information required to be made publicly available
      pursuant to the requirements of the Company’s Bank Regulator.
    </>
  ),
  details: {
    desc: 'Provide the name(s) of the primary federal regulator(s) with oversight of the Company’s business activities (any or all of the Federal Deposit Insurance Corporation (FDIC), Federal Reserve, or Office of the Comptroller of the Currency (OCC))',
    label: 'Name(s)',
    placeholder: 'Provide name(s) of your primary federal regulator here.',
    fieldName: 'reportingStandardDetail',
    height: 80,
    maxLength: 1500,
    isRequired: true,
    inputType: 'textarea',
  },
};

const DNS_ALTERNATIVE = {
  id: reportingStandards.ALTERNATIVE,
  testId: 'reporting-standard-alternative',
  component: () => <>
    The company is not subject to SEC reporting requirements, and intends to make disclosure pursuant to the <a href={urls.OTCID_GUIDLINES} target='_blank' rel='noopener noreferrer'>OTCID Disclosure Guidelines.</a>
  </>
};

const DNS_INTERNATIONAL = {
  id: reportingStandards.INTERNATIONAL,
  testId: 'reporting-standard-international',
  desc: 'The Company is listed on a non-U.S. stock exchange and is exempt from SEC registration under Exchange Act Rule 12g3-2(b).'
};

const DNS_SEC = {
  id: reportingStandards.SEC,
  testId: 'reporting-standard-sec',
  component: () => (
    <>
      The company has a reporting obligation under Section 13 or 15(d) of the
      Exchange Act, or under Regulation A (Tier 2), or under Regulation
      Crowdfunding.
    </>
  ),
  details: {
    label: 'Enter the 10-digit Central Index Key (CIK) assigned by the SEC.',
    placeholder: 'Provide CIK here.',
    fieldName: 'cikNumber',
    height: 40,
    maxLength: 10,
    isRequired: false,
    inputType: 'textbox',
    errorText: (value) => (value ? errors.CIK : null),
    isValid: (value) => (value ? isCIK(value) : true),
  },
};

const reportingStandardOtcxUsOptions = [SEC, REGULATION, ALTERNATIVE];

const reportingStandardOtcxBanksOptions = [SEC, REGULATION];

const reportingStandardOtcxIntlOptions = [INTERNATIONAL, SEC, REGULATION];

const reportingStandardOtcqbOptions = [SEC, INTERNATIONAL, REGULATION, ALTERNATIVE];

const reportingStandardDnsOptions = [DNS_ALTERNATIVE, DNS_BANK, DNS_INTERNATIONAL, DNS_SEC];

export const reportingStandardOptionsMap = new Map([
  [appTypeIds.OTCQX_US, reportingStandardOtcxUsOptions],
  [appTypeIds.OTCQX_BANKS, reportingStandardOtcxBanksOptions],
  [appTypeIds.OTCQX_INTL, reportingStandardOtcxIntlOptions],
  [appTypeIds.OTCQB, reportingStandardOtcqbOptions],
  [appTypeIds.DNS, reportingStandardDnsOptions]

]);

export const US_BANK = {
  id: reportingStandards.BANK,
  testId: 'reporting-standard-us-bank',
  desc: 'The Company is not subject to SEC or Reg A Reporting requirements, but will provide all information required to have been made publicly available pursuant to the requirements of the Company’s Bank Regulator.',
  details: {
    desc: 'Provide the name(s) of the primary federal regulator(s) with oversight of the Company’s business activities (any or all of the Federal Deposit Insurance Corporation (FDIC), Federal Reserve, or Office of the Comptroller of the Currency (OCC)).',
    label: 'Name(s)',
    placeholder: 'Provide name(s) of your primary federal regulator here.',
    fieldName: 'reportingStandardDetail',
    height: 80,
    maxLength: 1500,
    isRequired: true,
    inputType: 'textarea',
  },
};
